export const API_URL = `https://forkify-api.herokuapp.com/api/v2/recipes`;
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const API_KEY = '98471bb8-4a91-4fd5-a361-3cd753561799';
export const MODAL_CLOSE_SEC = 1;
